import React, { useEffect, useRef } from "react";
import Helper from "../../helper";

const images = [
  "https://images.staticcontent.io/casino/without-login/topgame/topgame5.webp",
  "https://images.staticcontent.io/casino/without-login/topgame/topgame9.webp",
  "https://images.staticcontent.io/casino/without-login/topgame/topgame3.webp",
  "https://images.staticcontent.io/casino/without-login/topgame/topgame4.webp",
  "https://images.staticcontent.io/casino/without-login/topgame/topgame5.webp",
  "https://images.staticcontent.io/casino/without-login/topgame/topgame6.webp",
  "https://images.staticcontent.io/casino/without-login/topgame/topgame7.webp",
  "https://images.staticcontent.io/casino/without-login/topgame/topgame8.webp",
  "https://images.staticcontent.io/casino/without-login/topgame/topgame9.webp",
];

function TopGameSlider() {
  const scrollRef = useRef(null);
  const userInfo = Helper();

  useEffect(() => {
    const container = scrollRef.current;

    const scrollStep = () => {
      if (container) {
        const imageWidth = 82 + 2; // 82px width + 2px padding (adjust if needed)
        container.scrollLeft += imageWidth;

        // Reset if it reaches halfway (start of second image set)
        if (container.scrollLeft >= container.scrollWidth / 2) {
          container.scrollLeft = 0;
        }
      }
    };

    const interval = setInterval(scrollStep, 1500); // 1.5 second delay

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`mt-1 overflow-hidden ${userInfo ? 'hidden' : 'block'}`}>
      <div className="text-start  font-bold text-[16px] text-black leading-[24px]">
        Top Games
      </div>
      <div
        ref={scrollRef}
        className="flex overflow-x-auto no-scrollbar whitespace-nowrap mb-2"
        style={{ scrollBehavior: "smooth" }} // ✅ Smooth scroll effect
      >
        {/* Duplicate images for seamless loop */}
        {[...images, ...images].map((src, idx) => (
          <div
            key={idx}
            className=" h-[62px] md:w-[206px] md:h-[145px] rounded-lg px-[1px] overflow-hidden flex-shrink-0"
          >
            <img
              src={src}
              alt={`game-${idx}`}
              className="w-full  h-full object-cover"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default TopGameSlider;
